import { useState, useEffect } from 'react';
import { getTranslations, TranslationKeys } from './translations';

// Custom hook for translations
export const useTranslation = (language: string) => {
  const [translations, setTranslations] = useState<TranslationKeys>(getTranslations(language));
  
  // Update translations when language changes
  useEffect(() => {
    setTranslations(getTranslations(language));
  }, [language]);
  
  // Function to format dates according to the current language
  const formatDate = (date: string | Date, options?: Intl.DateTimeFormatOptions) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString(language, options);
  };
  
  // Function to format numbers according to the current language
  const formatNumber = (number: number, options?: Intl.NumberFormatOptions) => {
    // Handle undefined, null, or NaN values
    if (number === undefined || number === null || isNaN(number)) {
      return '0';
    }
    return number.toLocaleString(language, options);
  };
  
  // Function to format distances based on the selected unit (kilometers rounded)
  const formatDistance = (distance: number, distanceUnit?: string): string => {
    if (distanceUnit === 'miles') {
      const miles = Math.round(distance * 0.621371);
      return `${formatNumber(miles)} ${translations.milesUnit}`;
    }
    return `${formatNumber(Math.round(distance))} ${translations.km}`;
  };
  
  return {
    t: translations,
    formatDate,
    formatNumber,
    formatDistance,
    language
  };
};